import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import Sidebar from '~/Share/components/NextGen/Sidebar';
import Report from '~/Share/components/Report';
import ScrollableContent from '~/Share/containers/ScrollableContent';
import type { ReduxState } from '~/types/redux/share';
import { addUtmToLink } from '~/utils/add-utm-to-link';
import { useMedia } from 'react-use-media';

const StyledReport = styled(Report)`
  position: absolute;
  display: block;
  bottom: 7px;
  left: 25;
  z-index: 2;

  @media (max-width: 600px) {
    display: none !important;
  }
`;

const Container = styled.div<{ hasBackgroundImage: boolean }>`
  @media (max-width: 600px) {
    background-color: ${(props) =>
      props.hasBackgroundImage ? 'transparent' : '#E7E7E7'};
  }
`;

export type NextGenProps = {
  slug: string;
  hideReport?: boolean;
  showSingleColumnLayout: boolean;
  hideSocialShareBar?: boolean;
};

export default function NextGen({
  slug,
  showSingleColumnLayout,
  hideReport = false,
  hideSocialShareBar = false,
}: NextGenProps) {
  const isMobile = useMedia({
    maxWidth: 850,
  });

  const {
    model,
    landingPageType,
    messageTemplate,
    features,
    modelId,
    hasCustomLogo,
  } = useSelector((state: ReduxState) => ({
    model: state.root.model,
    messageTemplate: state.root.messageTemplate,
    features: state.root.features,
    modelId: state.root.model.id,
    landingPageType: state.root.type,
    hasCustomLogo: state.root.messageTemplate.has_custom_logo,
  }));

  return (
    <Container
      className='nextgen'
      hasBackgroundImage={!!messageTemplate.background_url}
    >
      {!showSingleColumnLayout && (
        <ScrollableContent
          model={model}
          landingPageType={landingPageType}
          messageTemplate={messageTemplate}
          slug={slug}
          useCustomLogo={features.canCustomiseLandingPage as boolean}
          showSingleColumnLayout={showSingleColumnLayout}
          showSocialShareBar={
            !hideSocialShareBar && messageTemplate.is_greet_shareable
          }
          showBonjoroBadge={!features.shouldHideBonjoroBranding}
          anchorUrl={
            !hasCustomLogo
              ? addUtmToLink('https://www.bonjoro.com', {
                  utm_source: 'video_messaging_landing_page',
                  utm_medium: isMobile
                    ? 'bonjoro_logo-mobile'
                    : 'bonjoro_logo-desktop',
                  utm_campaign: 'video_messaging_plg',
                })
              : undefined
          }
        />
      )}
      {!hideReport && (
        <StyledReport modelId={modelId} landingPageType={landingPageType} />
      )}
      <Sidebar
        singleColumnLayout={showSingleColumnLayout}
        hideReport={hideReport}
        showSocialShare={
          !hideSocialShareBar && messageTemplate.is_greet_shareable
        }
      />
    </Container>
  );
}
